import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface ProfileUserData {
  unique_id: string;
  user_type: string;
  first_name: string | null;
  middle_name: string | null;
  last_name: string | null;
  display_name: string | null;
  email: string | null;
  mobile_code: string | null;
  mobile_number: string | null;
}

export interface ProfileResponse {
  status: boolean;
  message: string;
  data?: ProfileUserData;
}

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private readonly http = inject(HttpClient);

  getProfile(): Observable<ProfileResponse> {
    return this.http.get<ProfileResponse>(`${environment.apiBaseUrl}/v1/user/profile`);
  }
}
